// @ts-nocheck
import { apiRequest } from "../../services/apiService";

const addCustomMessage = ({
  payload,
  beforeCallback,
  afterCallback,
  successCallback,
  failureCallback
}) => {
  return async (dispatch, getState) => {
    if (beforeCallback) {
      beforeCallback();
    }

    const { response, error } = await apiRequest({
      method: "POST",
      url: "addTextMessage",
      isToken: true,
      data: payload
    }); 

    if (afterCallback) {
      afterCallback();
    }

    if (response) {
      if (successCallback) {
        successCallback({
          res: response
        });
      }
    } else {
      if (failureCallback) {
        failureCallback({
          error
        });
      }
    }
  };
};


const editCustomMessage = ({
  payload,
  params,
  beforeCallback,
  afterCallback,
  successCallback,
  failureCallback
}) => {
  return async (dispatch, getState) => {
    if (beforeCallback) {
      beforeCallback();
    }

    const { response, error } = await apiRequest({
      method: "PUT",
      url: "updateTextMessage",
      isToken: true,
      data: payload,
      params
    }); 

    if (afterCallback) {
      afterCallback();
    }

    if (response) {
      if (successCallback) {
        successCallback({
          res: response
        });
      }
    } else {
      if (failureCallback) {
        failureCallback({
          error
        });
      }
    }
  };
};


const deleteCustomMessage = ({
  params,
  beforeCallback,
  afterCallback,
  successCallback,
  failureCallback
}) => {
  return async (dispatch, getState) => {
    if (beforeCallback) {
      beforeCallback();
    }

    const { response, error } = await apiRequest({
      method: "PATCH",
      url: "deleteTextMessage",
      isToken: true,
      params
    });

    if (afterCallback) {
      afterCallback();
    }

    if (response) {
      if (successCallback) {
        successCallback({
          res: response
        });
      }
    } else {
      if (failureCallback) {
        failureCallback({
          error
        });
      }
    }
  };
};


const getCustomMessages = ({
  params,
  beforeCallback,
  afterCallback,
  successCallback,
  failureCallback
}) => {
  return async (dispatch, getState) => {
    if (beforeCallback) {
      beforeCallback();
    }

    const { response, error } = await apiRequest({
      method: "GET",
      url: "getTextMessages",
      isToken: true,
      params
    });

    if (afterCallback) {
      afterCallback();
    }

    if (response) {
      if (successCallback) {
        successCallback({
          res: response
        });
      }
    } else {
      if (failureCallback) {
        failureCallback({
          error
        });
      }
    }
  };
};

// Safety and harassment page actions...
const fetchSafetyAndHarassmentVideosAction = ({
  params,
  beforeCallback,
  afterCallback,
  successCallback,
  failureCallback
}) => {
  return async (dispatch) => {
    if (beforeCallback) {
      beforeCallback();
    }

    const { response, error } = await apiRequest({
      method: "GET",
      url: "getNonHarassmentVideo",
      isToken: true,
      params
    });

    if (afterCallback) {
      afterCallback();
    }

    if (response) {
      if (successCallback) {
        successCallback({
          res: response
        });
      }
    } else {
      if (failureCallback) {
        failureCallback({
          error
        });
      }
    }
  };
};

const uploadNewVideoAction = ({
  params,
  payload,
  beforeCallback,
  afterCallback,
  successCallback,
  failureCallback
}) => {
  return async (dispatch, getState) => {
    if (beforeCallback) {
      beforeCallback();
    }

    const { response, error } = await apiRequest({
      method: "POST",
      url: "uploadNonHarassmentVideo",
      data: payload,
      isToken: true,
      params
    });

    if (afterCallback) {
      afterCallback();
    }

    if (response) {
      if (successCallback) {
        successCallback({
          res: response
        });
      }
    } else {
      if (failureCallback) {
        failureCallback({
          error
        });
      }
    }
  };
}

const updateVideoAction = ({
  params,
  payload,
  beforeCallback,
  afterCallback,
  successCallback,
  failureCallback
}) => {
  return async (dispatch, getState) => {
    if (beforeCallback) {
      beforeCallback();
    }

    const { response, error } = await apiRequest({
      method: "PUT",
      url: "updateNonHarassmentVideo",
      data: payload,
      isToken: true,
      params
    });

    if (afterCallback) {
      afterCallback();
    }

    if (response) {
      if (successCallback) {
        successCallback({
          res: response
        });
      }
    } else {
      if (failureCallback) {
        failureCallback({
          error
        });
      }
    }
  };
}

const deleteVideoAction = ({
  params,
  beforeCallback,
  afterCallback,
  successCallback,
  failureCallback
}) => {
  return async (dispatch) => {
    if (beforeCallback) {
      beforeCallback();
    }

    const { response, error } = await apiRequest({
      method: "PATCH",
      url: "deleteNonHarassmentVideo",
      isToken: true,
      params
    });

    if (afterCallback) {
      afterCallback();
    }

    if (response) {
      if (successCallback) {
        successCallback({
          res: response
        });
      }
    } else {
      if (failureCallback) {
        failureCallback({
          error
        });
      }
    }
  };
};

const updateVideoWatchedStatusAction = ({
  params,
  payload,
  beforeCallback,
  afterCallback,
  successCallback,
  failureCallback
}) => {
  return async (dispatch) => {
    if (beforeCallback) {
      beforeCallback();
    }

    const { response, error } = await apiRequest({
      method: "PATCH",
      url: "updateVideoStatus",
      isToken: true,
      params,
      data: payload
    });

    if (afterCallback) {
      afterCallback();
    }

    if (response) {
      if (successCallback) {
        successCallback({
          response
        });
      }
    } else {
      if (failureCallback) {
        failureCallback({
          error
        });
      }
    }
  };
};
// Safety and harassment page actions...

export {
  addCustomMessage,
  editCustomMessage,
  deleteCustomMessage,
  getCustomMessages,
  fetchSafetyAndHarassmentVideosAction,
  uploadNewVideoAction,
  updateVideoAction,
  deleteVideoAction,
  updateVideoWatchedStatusAction
};